import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "CARD_STATEMENTS";
export const cardStatementConstants = createCRUDConstants(nameSpace);
